import React, { useState } from "react";
import withStyles from '@mui/styles/withStyles';
import checkMarkImage from "../../assets/images/check-mark-with-effects.svg";
import ArrowLeft from "../../assets/images/arrow-left.svg";
import ArrowLeftBlue from "../../assets/images/arrow-left-blue.svg";
import RoundButton from "./round-button";
import { useHistory } from "react-router-dom";
import PurchaseConfirmationModal from "./purchase-confirmation-modal";
import Error from "../error";
import Loading from "../loading";
import { CURRENT_USER_QUERY } from "../../queries/queries";
import { useQuery } from "@apollo/client";
import useMakeScrollable from "../../custom_hooks/make-scrollable";

const styles = (theme) => ({
  root: {
    background: "linear-gradient(340deg,#7CD1EA, #4295E6)",
    height: "100vh",
    overflow: "auto",
  },
  topTitle: {
    fontFamily: "Montserrat",
    fontSize: 27,
    fontWeight: 300,
    lineHeight: "40px",
    letterSpacing: -0.43,
    padding: "88px 65px 0px 65px",
    color: "#FFFFFF",
    textAlign: "center",
  },
  checkMarkImage: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    marginTop: 40,
  },
  afterCheckTitle: {
    fontFamily: "Montserrat",
    fontSize: 27,
    fontWeight: 300,
    lineHeight: "40px",
    letterSpacing: -0.43,
    padding: "40px 33px 26px 33px",
    color: "#FFFFFF",
    textAlign: "center",
  },
  purchaseConfirmation: {
    position: "absolute",
    height: "100vh",
    width: "100vw",
    top: 80,
    backgroundColor: "white",
    borderRadius: "15px 15px 0px 0px",
  },
});

const SuccessfulPurchase = ({
  match: {
    params: { campaignId },
  },
  classes,
}) => {
  useMakeScrollable()
  const history = useHistory();
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);

  const currentUser = useQuery(CURRENT_USER_QUERY, {
    fetchPolicy: "no-cache",
  });

  if (currentUser.loading) return <Loading />;
  if (currentUser.error) return <Error />;

  const isKyteTecMember = currentUser.data.currentUser.pharmacy.kyteTecStatus;

  console.log(isKyteTecMember);
  return (
    <div className={classes.root} id="scrollable">
      <div className={classes.topTitle}>
        Punkte erfolgreich für diesen Coupon eingelöst
      </div>
      <div className={classes.checkMarkImage}>
        <img src={checkMarkImage} alt="" />
      </div>
      <div className={classes.afterCheckTitle}>Was möchtest du tun?</div>
      {!!isKyteTecMember && (
        <RoundButton
          arrow={ArrowLeft}
          onClick={(e) => setShowPurchaseModal(true)}
        >
          Coupon Jetzt verwenden
        </RoundButton>
      )}

      <RoundButton
        arrow={ArrowLeftBlue}
        color="#238CB9"
        backgroundColor="white"
        onClick={(e) => history.push(`/coupons-list`)}
      >
        Meine Coupons
      </RoundButton>
      {showPurchaseModal && (
        <PurchaseConfirmationModal
          campaignId={campaignId}
          setShowPurchaseModal={setShowPurchaseModal}
        />
      )}
    </div>
  );
};
export default withStyles(styles)(SuccessfulPurchase);
